module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-568.b13cd0a.woff2";